export function CustomRegexUtils(props) {
    return {
        hasHttpPrefix: hasHttpPrefix,
        isValidUrlFormat: isValidUrlFormat,
        checkPhoneNumberFormat: checkPhoneNumberFormat
    }
}

function hasHttpPrefix(url) {
    const urlRegex = /^(https?:\/\/)/;

    if (urlRegex.test(url)) {
        return true;
    } else {
        return false;
    }
}

function isValidUrlFormat(url) {
    const regex = /^(https?:\/\/)?([\da-zㄱ-힣.-]+)\.([a-z.ㄱ-힣]{2,6})/;

    if (regex.test(url)) {
        return true;
    } else {
        return false;
    }
}

const checkPhoneNumberFormat = (phoneNumber) => {
    // let regex = /^01([0|1|6|7|8|9])[-.]?([0-9]{3,4})[-.]?([0-9]{4})$/;
    let regex = /^01([0|1|6|7|8|9])([0-9]{3,4})([0-9]{4})$/;
    return regex.test(phoneNumber);
}